import { makeClassName } from '@/utils';

export default function Typing(props) {
	return (
		<div class={makeClassName('typing')}>
			<div />
			<div />
			<div />
			<div />
			<div />
		</div>
	);
}
